<template>
  <div id="app">
    <!-- <router-view v-if="isRouterAlive"></router-view> -->
    <router-view ></router-view>
  </div>
</template>

<script>
	
export default {
  name: 'App',
  // provide() { // 注册一个方法
  //   return {
  //     reload: this.reload
  //   }
  // },
  // data() {
  //   return {
  //     isRouterAlive: true
  //   }
  // },
  // methods: {
  //   reload() {
  //     this.isRouterAlive = false
  //     this.$nextTick(function() {
  //       this.isRouterAlive = true
  //     })
  //   }
  // }
}
</script>

<style scoped>
#app{height: 100%;}
</style>



// WEBPACK FOOTER //
// src/App.vue